/* eslint-disable */
// @ts-nocheck

import React, { useContext } from 'react'

import { productTypes } from '@/utils/staticData'

import RadioGroupForm from '../../../components/forms/RadioGroup'
import { ProductContext } from '../../../containers/products/newProductModal/NewWizardContainer'
import { useAppSelector } from '../../../store/hooks'
import { getProductTypes } from '../../../utils/stylesHelpers'

const ProductTypeSelector = () => {
  const { control, stepUp } = useContext(ProductContext)
  const availableProdTypes = productTypes.map((item) => item.id).join(',')
  const productTypesRadio = getProductTypes(availableProdTypes ?? '')

  return (
    <>
      <div className="h-96 overflow-auto rounded border border-slate-300 p-2 pr-4 scrollbar-thin scrollbar-thumb-gray-200">
        <RadioGroupForm
          action={stepUp}
          control={control}
          data={productTypesRadio}
          name="type"
        />
      </div>
    </>
  )
}

export default ProductTypeSelector
